// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-retake-phone {
  border-radius: 0px 0px 10px 10px;
}

.container_retake-phone {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  min-height: calc(90vh - 120px);
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 24px;
}
.container_retake-phone h3 {
  color: #444;
  text-align: center;
  font-family: Roboto;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.container_retake-phone h4 {
  color: #00254A;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.container_retake-phone p {
  color: #00254A;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.container_retake-phone p b {
  color: #00254A;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/retake-phone/style.scss"],"names":[],"mappings":"AAAA;EACG,gCAAA;AACH;;AAEA;EACG,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AACH;AAAC;EACG,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AAAC;EACG,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AAAC;EACG,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AADE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAGJ","sourcesContent":[".header-retake-phone{\n   border-radius: 0px 0px 10px 10px;\n}\n\n.container_retake-phone{\n   display: flex;\n   flex-direction: column;\n   gap: 32px;\n   width: 100%;\n   min-height: calc(90vh - 120px);\n   padding-left: 16px;\n   padding-right: 16px;\n   padding-top: 24px;\n h3 {\n    color: #444;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n }\n h4 {\n    color: #00254A;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n }\n p {\n    color: #00254A;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  b {\n    color: #00254A;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 150% */\n  }\n }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
